import instance from '@apis/instance';
import {
    AttendanceCheckInResponse, AttendanceCheckInType,
    AttendanceEventPolicyResponse, AttendanceEventProgressResponse,
    EventResponse,
    EventRow,
} from '@models/event';
import { GetEventsParams } from '@models/event/request';
import { PageResponse } from '@models/page';

class EventApi {
    static attendanceCheckIn(
        eventId :string,
        checkInType: AttendanceCheckInType,
    ): Promise<AttendanceCheckInResponse> {
        return instance.post(`/events/${eventId}/attendance/check-in`, {
            checkInType,
        });
    }

    static getEvents(params: GetEventsParams): Promise<PageResponse<EventRow>> {
        return instance.get('/events', { params });
    }

    static getEvent(eventId: string): Promise<EventResponse> {
        return instance.get(`/events/${eventId}`);
    }

    static getAttendanceProgress(eventId: string): Promise<AttendanceEventProgressResponse> {
        return instance.get(`/events/${eventId}/attendance/progress`);
    }

    static getAttendancePolicy(eventId: string): Promise<AttendanceEventPolicyResponse> {
        return instance.get(`/events/${eventId}/attendance/policy`);
    }
}

export default EventApi;
